module.exports = __webpack_public_path__ + "media/images/logo-518fb3f6405b4ddf0287f1c91655e41b.png";